module.exports = __webpack_public_path__ + "static/A02-d7cae68567aa8cebd7d2626579c7b24d.jpg";